import axios, { CancelToken } from "axios"

import dayjs from "dayjs"
import localizedFormat from "dayjs/plugin/localizedFormat"
import "dayjs/locale/es"
dayjs.extend(localizedFormat)
dayjs.locale('es')


const Utils = {}

//Utils["Backend"] = ""
//Utils["Backend"] = `http://${window.location.hostname }:2023`
//Utils["Backend"] = `https://app.test.terrabella.pe`
Utils["Backend"] = `https://api.app.terrabella.pe`


Utils["TokenStorageKey"] = "TerraDashboard_SecureStorage"

Utils["GetAuthToken"] = () => {
	return localStorage.getItem(Utils.TokenStorageKey)
}

Utils["SetAuthToken"] = (Token) => {
	return localStorage.setItem(Utils.TokenStorageKey, Token)
}

Utils["DeleteAuthToken"] = () => {
	return localStorage.removeItem(Utils.TokenStorageKey)
}

Utils["AuthHeaders"] = () => {
	return Utils.GetAuthToken() !== null ?
	{
		headers: {
			Authorization: "Bearer " + Utils.GetAuthToken()
		}
	} : null
}


Utils["AlertError"] = (err, msg) => {
	if(err.response) {
		// show response from backend
		if(err.response && err.response.data.error) {
			alert('Error: '+ err.response.data.error)
		} else {
			alert(msg)
		}
	} else {
		alert(msg)
	}
}

Utils["dayjs"] = dayjs


Utils["rolInfo"] = (rol) => {
	switch(rol) {
		case "a":
			return { rol: "admin", color: "primary", nextRol: null }
		case "t":
			return { rol: "trabajador", color: "warning", nextRol: "u" }
		case "u":
			return { rol: "usuario", color: "success", nextRol: "t" }
		default:
			return { rol, color: "secondary", nextRol: rol }
	}
}

Utils['formatPrice'] = (input) => {
	// Convertir el input a un número
	var numero = parseFloat(input);

	// Verificar si el input es un número válido
	if (isNaN(numero)) {
		// Si no es un número válido, lanzar un error o manejar la situación según tu caso
		throw new Error("El input no es un número válido");
	}

	// Redondear el número a dos decimales
	var numeroRedondeado = numero.toFixed(2);
	// Convertir el número a string
	var numeroFormateado = numeroRedondeado.toString()
	
	// Dividir el número en partes enteras y decimales
	var partes = numeroFormateado.split(".")
	var parteEntera = partes[0]
	var parteDecimal = partes.length > 1 ? "." + partes[1] : ""

	// Agregar comas después de cada grupo de tres dígitos en la parte entera
	parteEntera = parteEntera.replace(/\B(?=(\d{3})+(?!\d))/g, ",")

	// Devolver el número formateado
	//return parteEntera + parteDecimal
	return parteDecimal === ".00" ? parteEntera : parteEntera + parteDecimal;
}
  

/*
    REST API
*/

Utils["API"] = {}

Utils["API"]["Login"] = (DNI, password) => (
    axios.post(`${Utils.Backend}/api/v1/Login`, {
		DNI,
		password
	})
)

Utils["API"]["exchangeToken"] = (token) => (
    axios.get(`${Utils.Backend}/api/v1/Adm/exchangeToken`, {
		headers: {
			Authorization: "Bearer " + token
		}
	})
)

Utils["API"]["checkToken"] = () => (
    axios.get(`${Utils.Backend}/api/v1/Adm/checkToken`, Utils.AuthHeaders())
)


Utils["API"]["ListarProyectos"] = () => (
    axios.get(`${Utils.Backend}/api/v1/Adm/Proyectos`, Utils.AuthHeaders())
)


Utils["API"]["ListarLotes"] = (Slug) => (
    axios.get(`${Utils.Backend}/api/v1/Adm/Proyectos/${Slug}/Lotes`, Utils.AuthHeaders())
)

Utils["API"]["SetLoteOcupado"] = (idLote, ocupado) => (
    axios.patch(`${Utils.Backend}/api/v1/Adm/Lotes/${idLote}`, {
		ocupado
	}, Utils.AuthHeaders())
)

Utils["API"]["ModificarLote"] = (idLote, Precio, Area, PartidaRegistral) => (
    axios.put(`${Utils.Backend}/api/v1/Adm/Lotes/${idLote}`, {
		Precio,
		Area,
		PartidaRegistral
	}, Utils.AuthHeaders())
)

Utils["API"]["CrearDescuento"] = (Slug, Inicial, Descuento, TipoDescuento, MaxMeses) => (
    axios.put(`${Utils.Backend}/api/v1/Adm/Proyectos/${Slug}/Descuentos`, {
		Inicial,
		Descuento,
		TipoDescuento,
		MaxMeses
	}, Utils.AuthHeaders())
)

Utils["API"]["EliminarDescuento"] = (idDescuento) => (
    axios.delete(`${Utils.Backend}/api/v1/Adm/Descuentos/${idDescuento}`, Utils.AuthHeaders())
)

Utils["API"]["CotizarLote"] = (idLote, cuotas, precio, inicial, diaMes, tieneReserva) => (
    axios.get(`${Utils.Backend}/api/v1/Adm/Lotes/${idLote}/Cotizar?cuotas=${cuotas}&precio=${precio}&inicial=${inicial}&diaMes=${diaMes}&tieneReserva=${tieneReserva}`, Utils.AuthHeaders())
)

/*
	Usuarios
*/

Utils["API"]["BuscarPersona"] = (q) => (
    axios.get(`${Utils.Backend}/api/v1/Adm/Usuarios/Buscar?q=${q}`, Utils.AuthHeaders())
)


Utils["API"]["ListarUsuarios"] = () => (
    axios.get(`${Utils.Backend}/api/v1/Adm/Usuarios`, Utils.AuthHeaders())
)

Utils["API"]["SetUsuarioActivo"] = (idUsuario, Activo) => (
    axios.post(`${Utils.Backend}/api/v1/Adm/Usuarios/${idUsuario}/SetActivo`, {
		Activo
	}, Utils.AuthHeaders())
)

Utils["API"]["SetUsuarioRol"] = (idUsuario, Rol) => (
    axios.post(`${Utils.Backend}/api/v1/Adm/Usuarios/${idUsuario}/SetRol`, {
		Rol
	}, Utils.AuthHeaders())
)

Utils["API"]["ModificarUsuario"] = (idUsuario, Celular, Email) => (
    axios.put(`${Utils.Backend}/api/v1/Adm/Usuarios/${idUsuario}`, {
		Celular,
		Email
	}, Utils.AuthHeaders())
)

/*
	Gestión de lotes
*/

Utils["API"]["SubirPDF"] = (Slug, type, fdata) => (
    axios.post(`${Utils.Backend}/api/v1/Adm/Proyectos/${Slug}/SubirPDF/${type}`, fdata, Utils.AuthHeaders())
)

Utils["API"]["VenderLote"] = (token, idUsuario) => (
    axios.post(`${Utils.Backend}/api/v1/Adm/Membresias/VenderLote`, {
		token,
		idUsuario
	}, Utils.AuthHeaders())
)

Utils["API"]["PagosVencidos"] = () => (
    axios.get(`${Utils.Backend}/api/v1/Adm/Pagos/ListarVencidos`, Utils.AuthHeaders())
)

Utils["API"]["PagosUsuario"] = (idUsuario) => (
    axios.get(`${Utils.Backend}/api/v1/Adm/Pagos/BuscarPorUsuario?idUsuario=${idUsuario}`, Utils.AuthHeaders())
)

Utils["API"]["MarcarPago"] = (idPago, monto) => (
    axios.post(`${Utils.Backend}/api/v1/Adm/Pagos/Marcar`, {
		idPago,
		monto
	}, Utils.AuthHeaders())
)

Utils["API"]["SubirFactura"] = (idPago, fdata) => (
    axios.put(`${Utils.Backend}/api/v1/Adm/Pagos/${idPago}/Factura`, fdata, Utils.AuthHeaders())
)

Utils["API"]["CambiarExpiracion"] = (idPago, FechaExpiracion) => (
    axios.put(`${Utils.Backend}/api/v1/Adm/Pagos/${idPago}/Expiracion`, {
		FechaExpiracion
	}, Utils.AuthHeaders())
)

/*
	CanjePremio
*/

Utils["API"]["CanjesPendientes"] = () => (
    axios.get(`${Utils.Backend}/api/v1/Adm/CanjePremio/Pendientes`, Utils.AuthHeaders())
)

Utils["API"]["EntregarPremio"] = (idCanje) => (
    axios.post(`${Utils.Backend}/api/v1/Adm/CanjePremio/MarcarEntrega`, {
		idCanje
	}, Utils.AuthHeaders())
)

/*
	Notificaciones / Marketing
*/

Utils["API"]["NotificarUsuario"] = (idUsuario, title, body) => (
    axios.post(`${Utils.Backend}/api/v1/Adm/Sesiones/NotificarUsuario`, {
		idUsuario,
		title,
		body
	}, Utils.AuthHeaders())
)

Utils["API"]["NotificarTodos"] = (title, body) => (
    axios.post(`${Utils.Backend}/api/v1/Adm/Sesiones/NotificarTodos`, {
		title,
		body
	}, Utils.AuthHeaders())
)

/*
	Cotizaciones
*/

Utils["API"]["CotizacionesPendientes"] = () => (
	axios.get(`${Utils.Backend}/api/v1/Adm/Cotizaciones`, Utils.AuthHeaders())
)

Utils["API"]["AtenderCotizacion"] = (idCotizacion) => (
	axios.patch(`${Utils.Backend}/api/v1/Adm/Cotizaciones/${idCotizacion}/MarcarAtencion`, {}, Utils.AuthHeaders())
)

export default Utils